import { HttpClient } from "../HttpClient";
/**
 * * Patch Default Deductions
 */
export const PatchDefaultDeductions = async (id, isDeleted) => {
	try {
		const { data } = await HttpClient.patch(`api/defaultDeductions/${id}/Status`, { ...isDeleted });
		return await Promise.resolve(data);
	} catch (err) {
		return Promise.reject(err);
	}
};
